import { getFileTypeLabel } from '../../utils/fileUtils';
import { formatIscLevelName } from '../../constants/record';

const CheckboxFilterGroup = ({
  label,
  options,
  selected,
  onToggle,
  emptyMessage,
  getOptionLabel,
}: {
  label: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
  emptyMessage: string;
  getOptionLabel: (value: string) => string;
}) => (
  <div>
    <label className="block text-xs font-medium text-gray-500 mb-1.5">{label}</label>
    {options.length === 0 ? (
      <p className="text-xs text-gray-400">{emptyMessage}</p>
    ) : (
      <ul className="space-y-1.5">
        {options.map((option) => (
          <li key={option}>
            <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer select-none">
              <input
                type="checkbox"
                checked={selected.includes(option)}
                onChange={() => onToggle(option)}
                className="w-3.5 h-3.5 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 focus:ring-offset-0"
              />
              {getOptionLabel(option)}
            </label>
          </li>
        ))}
      </ul>
    )}
  </div>
);

const FilterPanel = ({
  fileTypes,
  selectedFileTypes,
  onToggleFileType,
  iscLevels,
  selectedIscLevels,
  onToggleIscLevel,
}: {
  fileTypes: string[];
  selectedFileTypes: string[];
  onToggleFileType: (value: string) => void;
  iscLevels: string[];
  selectedIscLevels: string[];
  onToggleIscLevel: (value: string) => void;
}) => (
  <div className="space-y-4">
    <CheckboxFilterGroup
      label="File type"
      options={fileTypes}
      selected={selectedFileTypes}
      onToggle={onToggleFileType}
      emptyMessage="No file types available."
      getOptionLabel={getFileTypeLabel}
    />
    <CheckboxFilterGroup
      label="ISC"
      options={iscLevels}
      selected={selectedIscLevels}
      onToggle={onToggleIscLevel}
      emptyMessage="No classifications available."
      getOptionLabel={formatIscLevelName}
    />
  </div>
);

export default FilterPanel;
